import React from 'react';
import Progress from './progress';
import ListItem from './list_item';

const Interest = ({ data }) => (
  <section>
    <h1 className="section-header">Interests</h1>
    {data.map(interest => (
      <div key={interest.title} className="my-5">
        <h1 className="item-header font-semibold text-lg mb-2"></h1>
        {interest.examples.map(example => (
          <span key={example.name}>
            {interest.type === 'percent' && (
              <Progress name={example.name} percent={example.percent} />
            )}
            {interest.type === 'tag' && (
              <span key={example.name} className="tag">
                {example.name}
              </span>
            )}
            {interest.type === 'list' && (
              <ListItem key={example.name} text={example.name} />
            )}
          </span>
        ))}
      </div>
    ))}
  </section>
);

export default Interest;
